<proffeo-ui-dialog
  [title]="'copy-task-modal.title' | translate"
  class="relative"
>
  <div
    [proffeoSpinner]="isCopying()"
    proffeoSpinnerSize="lg"
    class="relative flex w-full flex-col gap-3"
  >
    <proffeo-ui-select
      (valueChange)="onProjectSelected($event)"
      [compareWith]="compareProjects"
      [options]="projectOptions()"
      [translateLabels]="false"
      [value]="selectedProject()"
      label="copy-task-modal.target-project"
      class="w-full"
    />

    <p class="text-sm text-proffeo-text">
      {{ 'copy-task-modal.description' | translate: { taskName: data.task.name } }}
    </p>

    <mat-checkbox
      (change)="toggleAllCheckboxes($event.checked)"
      [checked]="allSelected()"
      [indeterminate]="someSelected()"
      [disabled]="isCopying()"
      class="text-sm border-b border-proffeo-overlay-subtle pb-2"
    >
      {{ 'copy-task-modal.select-all' | translate }}
    </mat-checkbox>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 w-full">
      @for (option of options; track option.key) {
        <mat-checkbox
          (change)="toggle(option.key, $event.checked)"
          [checked]="settings()[option.key]"
          [disabled]="isCopying()"
          class="text-sm text-proffeo-text"
        >
          {{ option.labelKey | translate }}
        </mat-checkbox>
      }
    </div>
  </div>

  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      [disabled]="isCopying()"
      mat-dialog-close
      text="common.cancel"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="onCopy()"
      [disabled]="isCopying()"
      variant="accent"
      text="copy-task-modal.copy"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
